import { render, staticRenderFns } from "./model-r1-edit.vue?vue&type=template&id=12d10f6a&scoped=true&"
import script from "./model-r1-edit.vue?vue&type=script&lang=js&"
export * from "./model-r1-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d10f6a",
  null
  
)

export default component.exports